import Authenticate from './Authenticate';
import { connect } from 'react-redux';
import { userAuthenticated } from '../actions';

export { withAuthenticationContext, useAccount, useLogout, useAccessTokens, useUserProfile } from './Authenticate';

const mapStateToProps = ({ site }) => ({
    authConfig: site.authentication,
});

const mapDispatchToProps = {
    userAuthenticated,
};

export default connect(mapStateToProps, mapDispatchToProps)(Authenticate);
